
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Channel extends Vue {
  @Prop() readonly channel!: Record<string, unknown>
  @Prop() readonly params!: Record<string, unknown>

  component: Function | null = null

  loadComponent (name: string) {
    return () => import(
      `@/components/channels/${name}.vue`
    )
  }

  created () {
    if (this.channel.name === 'abc') {
      this.component = this.loadComponent('Abc')
    } else if (this.channel.name === 'googlebm') {
      this.component = this.loadComponent('GoogleBM')
    } else if (this.channel.name === 'messenger') {
      this.component = this.loadComponent('Messenger')
    } else if (this.channel.name === 'telegram') {
      this.component = this.loadComponent('Telegram')
    } else if (this.channel.name === 'web_chat') {
      const params = {
        settings: this.channel.settings,
        ...this.params
      }
      this.$store.commit('webchat/initial', params)
      this.component = this.loadComponent('WebChat')
    } else if (this.channel.name === 'chatbox') {
      if (this.params) {
        const params = {
          settings: this.channel.settings,
          ...this.params
        }
        this.$store.commit('webchat/initial', params)
      }
      this.component = this.loadComponent('Chatbox')
    } else if (this.channel.name === 'whatsapp') {
      this.component = this.loadComponent('WhatsApp')
    }
  }
}
